<!-- Do not change this file. -->

<template>
  <div class="showAboveFullScreenComponents bg-white">
    <div class="container-fluid border-top py-3 text-small">
      <div class="row">
        <div class="col text-start">
          &copy; {{ year }} Oregon State University
        </div>
        <div class="col text-end">
          <TheDebugger />

          <button class="btn btn-link m-0 p-0" @click="toggleVersion">
            {{ version }}
          </button>
          <a
            class="ms-3"
            rel="noopener"
            target="_blank"
            href="https://main.oregonstate.edu/digital-millennium-copyright-act-contact-information"
            >Copyright</a
          >

          <a
            class="ms-3"
            rel="noopener"
            target="_blank"
            href="https://oregonstate.edu/official-web-disclaimer"
            >Disclaimer</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Do not change this file. */
import TheDebugger from "@/components/debug/TheDebugger";

export default {
  name: "Footer",
  components: {
    TheDebugger
  },
  data: () => {
    return {
      publishYear: process.env.VUE_APP_PUBLISH_YEAR,
      showVersion: false
    };
  },
  props: {},
  computed: {
    year() {
      const currentYear = new Date().getFullYear(); // YYYY

      let yearString = "";
      /* Return just a single year */
      if (currentYear == this.publishYear) {
        yearString = `${currentYear}`;
      } else {
        /* Return a year range */
        yearString = `${this.publishYear} - ${currentYear}`;
      }

      return yearString;
    },
    version() {
      let version = "";

      if (this.showVersion) {
        version = document.lastModified;
      } else {
        version = require("./../../../package.json").version;
      }

      return version;
    }
  },
  methods: {
    toggleVersion() {
      this.showVersion = !this.showVersion;
    }
  }
};
</script>

<style scoped>
.text-small {
  font-size: 0.8em;
}

.btn {
  font-size: inherit;
}

a,
.btn {
  text-decoration: none;
}

a:hover,
.btn:hover {
  text-decoration: underline;
}
</style>
